import Primary from "../layouts/Primary";

import './AllianceSelection.css'
import ScrollingTable from "../components/ScrollingTable";
import {t} from "../../i18n";
import AllianceBar from "../components/AllianceBar";
import {DisplayCommand, ShowSelection, TeamSelectionState} from "../../javaTypes";
import {DisplayConfig} from "../Config";
import Blank from "./Blank";

function AllianceColumn({teams, lastColumn} : {
    teams: TeamSelectionState[],
    lastColumn: boolean
}) {
    return <ScrollingTable
                    colorCol={'color'}
                    classCol={'className'}
                    height={'815px'}
                    keyCol={'rawNumber'}
                    disableScroll={!lastColumn}
                    columns={[
                        {
                            name: t`Rank`,
                            field: 'rank'
                        },
                        {
                            name: t`Team`,
                            field: 'number'
                        }
                    ]}
                    noHeading
                    data={teams.map((t, idx) => {
                            const unavailable = t.picked || t.captain || t.declined || t.removed;
                            return {
                                rawNumber: t.number,
                                rank: t.rank,
                                number: t.displayNumber,
                                className: unavailable ? 'unavailable' : ''
                            }
                        })}
    />
}

export default function AllianceSelection({command, config} : {
    command: DisplayCommand<ShowSelection>,
    config: DisplayConfig
}) {
    if(config.type == 'cmpBar') {
      return <Blank config={config} />;
    }

    const hybrid = config.overlay && config.allianceSelectionStyle === 'hybrid'
    const state = command.params.state
    const currentCaptain = state?.alliances && state.nextSlot < state.alliances.length * 2 ? (state?.teams || []).filter(t => !t.removed && !t.captain && !t.picked)[0].number : 0
    const allTeams = state ? state.teams.map(t => {
        if(t.number == currentCaptain) {
            return {
                ...t,
                captain: true
            }
        } else {
            return t
        }
    }) : []
    const compactList = allTeams.length > (hybrid ? 48 : 60);
    const hugeList = !hybrid && allTeams.length < 25;
    const perColumn = compactList ? 16 : (hugeList ? 10 : 12);

    const chunkedTeams = allTeams.reduce<TeamSelectionState[][]>((resultArray, item, index) => {
        // 12 per chunk, never more than 4 columns
        const chunkIndex = Math.min(Math.floor(index / perColumn), hybrid ? 4 : 5);

        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
        }

        resultArray[chunkIndex].push(item);

        return resultArray
    }, [])
    // never let there be less than 3 columns in non-hybrid
    for(let i = chunkedTeams.length; i <= (hybrid ? 1 : 2); i++) {
        chunkedTeams[i] = [];
    }
    const currentAlliance = state ? state.nextSlot >= (state.alliances.length * 2) ? (state.alliances.length * 3 - 1) - state.nextSlot : state.nextSlot / 2 : -1;
    const allianceCount = state?.alliances.length || 4;

    return <Primary className={`selectionPage ${hybrid ? 'hybridSelection' : 'classicSelection'} ${hybrid && config.overlayColor == 'transparent' ? 'transparent' : 'null'}`}>
            <div className={"allianceBarsWrapper"}>
               <div className={"allianceBars"} style={{
                   gridTemplateRows: `repeat(${hybrid ? Math.ceil(allianceCount / 2) : allianceCount}, minmax(0, 1fr))`,
               }}>
                   {hybrid ? null : <AllianceBar caption teamCount={state?.teamsPerAlliance || 2} />}
                   {state ?
                       state.alliances.map((alliance, idx) =>
                           // remove non-finalized alliance captains (treat the next captain as already finalized)
                           <AllianceBar withAvatar key={idx + 1} seed={idx + 1} teamCount={state.teamsPerAlliance} alliance={alliance.map(t => state.teams
                               .some(t2 => t == t2.number && !t2.captain && !t2.picked) && state.nextSlot != (idx) * 2 ? undefined : t)
                               .filter((t): t is number => !!t)
                               .map(t => (state.teams.find(t2 => t == t2.number) || { displayNumber: t.toString() })) } color={idx == currentAlliance ? "orange" : undefined}/>) :
                       [1,2,3,4].map((i) => <AllianceBar key={i} seed={i} alliance={[]}/>)}
               </div>
            </div>
           <div className="chromaBackground" style={{ background: config.overlayColor }} />
           <div className={`teamListContainer ${compactList ? 'compact' : ''} ${hugeList ? 'huge' : ''}`}>
               {chunkedTeams.map((teamList, i) => <AllianceColumn key={i} teams={teamList} lastColumn={i === chunkedTeams.length - 1}/>)}
           </div>
    </Primary>;
}